import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { List } from 'antd'
import { Button } from 'ui/styled'
import PropTypes from 'prop-types'
import React from 'react'
import { ListItemCentered } from './styled'

const FacilityList = ({
  facilities = [],
  onEditFacility,
  onRemoveFacility
}) => (
  <List>
    {facilities.map(({ id, name, navigator_notes }) => (
      <ListItemCentered key={id}>
        <List.Item.Meta
          title={name}
          description={navigator_notes ? ` "${navigator_notes}"` : ''}
        />
        <Button
          btntype="link"
          data-test="editFacilityBtn"
          icon={<EditOutlined />}
          onClick={() => onEditFacility(id)}
        >
          Edit
        </Button>
        <Button
          btntype="link"
          data-test="deleteFacilityBtn"
          icon={<DeleteOutlined />}
          onClick={() => onRemoveFacility({ id })}
        >
          Remove
        </Button>
      </ListItemCentered>
    ))}
  </List>
)

FacilityList.propTypes = {
  facilities: PropTypes.array,
  onRemoveFacility: PropTypes.func.isRequired,
  onEditFacility: PropTypes.func.isRequired
}

export default FacilityList
